module.exports = __webpack_public_path__ + "static/media/petimg.6a0ce57d.png";